export const TABLE_FETCH_AGAIN = "TABLE_FETCH_AGAIN"
export const EMPTY_OFFLINE_STORE_DATA = "EMPTY_OFFLINE_STORE_DATA"